import React from 'react';
import { FlexGrid } from '@telus-uds/components-web';
import DiscountItem from '../discountItem/discountItem';

const DiscountApprovalList = ({discounts, appliedDiscountId, onApplyDiscount, onOverrideDiscount, term, managedItServicesTotal, onboardingFee}) => {
  if (!discounts.length) return null;

  const handleOverride = (e, id) => {
    e.preventDefault();
    onOverrideDiscount(e, id)
  };

  return (
    <>
      <FlexGrid>
        <FlexGrid.Row>
          {discounts.map(widget => (
            <FlexGrid.Col xs={12} sm={6} md={6} lg={4} key={widget.id}>
              <DiscountItem
                id={widget.id}
                status={widget.status}
                onetime={widget.onetime}
                monthly={widget.monthly}
                approvedOnetime={widget.approvedOnetime}
                approvedMonthly={widget.approvedMonthly}
                approvedDiscount={widget.approvedDiscount}
                overrideMonthly={widget.overrideMonthly}
                overrideOnetime={widget.overrideOnetime}
                onOverride={e => handleOverride(e, widget.id)}
                onApply={(action) => onApplyDiscount(widget.id, action)}
                applied={appliedDiscountId === widget.id}
                term={widget.term}
                formTerm={term}
                comment={widget.comment}
                order={widget.order}
                managedItServicesTotal={managedItServicesTotal}
                onboardingFee={onboardingFee}
                commentFromApprover={widget.commentFromApprover}
                requestedForManagedITServicesValue={widget.requestedForManagedITServicesValue}
                requestedForOnboardingFeeValue={widget.requestedForOnboardingFeeValue}
              />
            </FlexGrid.Col>
          ))}
        </FlexGrid.Row>
      </FlexGrid>
    </>
  );
};

export default DiscountApprovalList;
